export function isUserDetails(value) {
    if (!value || typeof value !== 'object')
        return false;
    var user = value;
    return (typeof user['first-name'] === 'string' &&
        typeof user['birth-year'] === 'string' &&
        typeof user['last-name'] === 'string' &&
        typeof user['email'] === 'string' &&
        typeof user['contact-number'] === 'string' &&
        typeof user['consent'] === 'boolean' &&
        typeof user['newsletter-consent'] === 'boolean');
}
